import React, { StrictMode } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App";
import "./assets/style/style.scss";
import "./assets/style/_footer.scss";
import reportWebVitals from "./reportWebVitals";
import { registerIcons } from "./config/fa.config";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Unregister any existing service workers immediately to prevent blocking JS on first visit
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
  // Also unregister using the service worker registration utility
  serviceWorkerRegistration.unregister();
}

registerIcons();

const appElement = (
  <BrowserRouter>
    <HelmetProvider>
      <StrictMode>
        <App />
      </StrictMode>
    </HelmetProvider>
  </BrowserRouter>
);

const container = document.getElementById("root") as HTMLElement;
const hasChildNodes = container?.hasChildNodes() ?? false;

hasChildNodes
  ? hydrateRoot(container, appElement)
  : createRoot(container).render(appElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
